import React, {ChangeEvent, FormEvent, useCallback, useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import SiteWrapper from "../../base/SiteWrapper";

import {ApiFidegg} from '../../services/apiFideggAdmin';

import {Button, Card, Form, Page} from "tabler-react";
import {Alerta} from "../../utils/Alerta";
import Params from "../../interfaces/Params";
import CashbackStatement, {StatementTypeEnum} from "../../interfaces/CashbackStatement";
import {formatMoney} from "../../utils/formatMoney";

interface CashbackStatementParams extends Params {
  customer_id: any
}

export default function CashbackStatementsForm() {

  const history = useHistory();
  const { customer_id, id } = useParams<CashbackStatementParams>();

  const initialValues = {
    value: formatMoney('0'),
    expiration_date: "",
    customer_id: customer_id,
    type: StatementTypeEnum.INCOME,
  } as CashbackStatement;

  const [cashback, setCashback] = useState<CashbackStatement>(initialValues);

  useEffect(() => {
    (async () => {
      if (!!id) {
        try {
          const cashbackTransaction = await ApiFidegg.get(`cashbackstatements/${id}`);
          if (cashbackTransaction.status === 200) {
            const data = cashbackTransaction.data;
            setCashback({
              ...data,
            });
          }
        } catch (e) {
          console.error(e);
        }
      }
    })();
  }, [id]);

  function handleMoneyChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    const masked = formatMoney(value);
    setCashback({ ...cashback, [name]: masked });
  }

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      try {
        event.preventDefault();

        const numericValue = Number(
            cashback.value.toString().replace(/\./g, "").replace(",", ".").replace("R$", "")
        );

        if (!numericValue) {
          Alerta('É necessário preencher o campo "valor".', "info")
          return;
        }

        if (cashback.type === StatementTypeEnum.INCOME && !cashback.expiration_date) {
          Alerta('É necessário preencher a data de expiração.', "info")
          return;
        }

        const data = {
          value: numericValue,
          expiration_date: cashback.expiration_date,
          customer_id: customer_id,
          type: cashback.type,
          description: cashback?.description,
        };

        await ApiFidegg.post('cashbackstatements', data)
        Alerta('Transação incluída!', 'success');

        history.push(`/customers/cashback-statement/${customer_id}`);
      } catch (err: any) {
        const apiMessage =
            err?.response?.data?.error?.message ||
            err?.response?.data?.message ||
            err?.message ||
            'Erro ao incluir transação!';

        Alerta(apiMessage, 'error');
      }
    },
    [history, id, customer_id, cashback]
  );

  function handleClickCancel(event: FormEvent) {
    event.preventDefault();
    history.goBack();
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    let { name, value } = event.target;

    setCashback({ ...cashback, [name]: value });
  }

  function handleSelectChange(event: ChangeEvent<HTMLSelectElement>) {
    const { name, value } = event.target;
    setCashback({ ...cashback, [name]: value });
  }

  const StatementTypes = [
    { id: 'income', label: 'Crédito' },
    { id: 'expense', label: 'Resgate' }
  ];

  return (
      <SiteWrapper>
        <Form onSubmit={handleSubmit}>
          <Page.Card
              title="Transação"
              footer={
                <Card.Footer>
                  <div className="d-flex">
                    <Button link onClick={handleClickCancel}>Cancelar</Button>
                    <Button type="submit" color="primary" className="ml-auto">
                      Salvar
                    </Button>
                  </div>
                </Card.Footer>
              }
          >

            <div style={{ display: "flex", gap: "20px" }}>
              <Form.Group label="Tipo" style={{ flex: 1 }}>
                <Form.Select
                    value={cashback.type}
                    onChange={handleSelectChange}
                    name="type"
                >
                  {StatementTypes.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.label}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group label="Valor" style={{ flex: 1 }}>
                <Form.Input
                    name="value"
                    value={cashback.value || ""}
                    onChange={handleMoneyChange}
                />
              </Form.Group>

              <Form.Group label="Data de expiração" style={{ flex: 1 }}>
                <Form.Input
                    type="date"
                    name="expiration_date"
                    value={cashback.expiration_date || ""}
                    onChange={handleChange}
                />
              </Form.Group>
            </div>

            <Form.Group label="Descrição">
              <Form.Input
                  name="description"
                  value={cashback.description || ""}
                  onChange={handleChange}
              />
            </Form.Group>

          </Page.Card>
        </Form>
      </SiteWrapper>
  );
}
